import React, { useEffect, useRef, useState } from "react";
import { startTransition } from "react";
import { SliderComponent } from "./SliderComponent";
import { useNavigate } from "react-router-dom";
import { getAllActivity, getCountAllActivity } from "../../../asiosConfig";

import {
  getActivityCountJava,
  getAllActivityJava,
} from "../../../javaAxiosConfig";

import { toast } from "react-toastify";

import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
  Skeleton,
} from "@mui/material";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../../services/firebaseConfig";

import backArrow from "../../../images/arrow-leftBack.svg";
import arrowLeft from "../../../images/left.svg";
import arrowRight from "../../../images/right.svg";

import MyMatchesIcon from "../../../images/MyMatches-Activity-icon.svg";
import InterestRejectIcon from "../../../images/InterestReject-Activity-icon.svg";
import InterestReceivedIcon from "../../../images/InterestReceived-Activity-icon.svg";
import InterestAcceptIcon from "../../../images/InterestAccept-Activity-icon.svg";

import BLOCKEDUSERIcon from "../../../images/BLOCKEDUSER.svg";
import MYONLINEMATCHESIcon from "../../../images/MYONLINEMATCHES.svg";
import CONTACTIVIEWEDIcon from "../../../images/CONTACTIVIEWED.svg";
import FEATUREDPROFILEIcon from "../../../images/FEATUREDPROFILE.svg";
import INTERESTSENTIcon from "../../../images/INTERESTSENT.svg";
import LOOKINGFORMEIcon from "../../../images/LOOKINGFORME.svg";
import RECENTLYJOINPROFILEIcon from "../../../images/RECENTLYJOINPROFILE.svg";
import MATCHIIGNOREIcon from "../../../images/MATCHIIGNORE.svg";
import MYBOOKMARKIcon from "../../../images/MYBOOKMARK.svg";
import PREMIUMMATCHESIcon from "../../../images/PREMIUMMATCHES.svg";
import WHOSHORTLISTMEIcon from "../../../images/WHOSHORTLISTME.svg";
import WHOVIEWMYPROFILEIcon from "../../../images/WHOVIEWMYPROFILE.svg";

import SugestedUserIcon from "../../../images/SuggestedUserIcon.svg";

export const Activity = () => {
  const [activity, setActivity] = useState([]);
  const [activityCount, setActivityCount] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  const getActivityIcon = (key) => {
    const k = key.toLowerCase();

    if (k === "my_matches") return MyMatchesIcon;
    if (k === "premium") return PREMIUMMATCHESIcon;

    if (k === "interest_received") return InterestReceivedIcon;
    if (k === "interest_i_accept") return InterestAcceptIcon;
    if (k === "interest_i_reject") return InterestRejectIcon;
    if (k === "interest_sent") return INTERESTSENTIcon;

    if (k === "my_interest_accepted") return InterestAcceptIcon;
    if (k === "my_interest_rejected") return InterestRejectIcon;

    if (k === "my_bookmark") return MYBOOKMARKIcon;

    if (k === "who_view_my_profile") return WHOVIEWMYPROFILEIcon;
    if (k === "who_short_list_me") return WHOSHORTLISTMEIcon;
    if (k === "who_looking_for_me") return LOOKINGFORMEIcon;

    if (k === "contact_i_viewed") return CONTACTIVIEWEDIcon;

    if (k === "my_online_matches") return MYONLINEMATCHESIcon;

    if (k === "featured_profile") return FEATUREDPROFILEIcon;

    if (k === "match_i_ignore") return MATCHIIGNOREIcon;

    if (k === "recently_join_profile") return RECENTLYJOINPROFILEIcon;

    if (k === "blocked_user") return BLOCKEDUSERIcon;

    if (k === "suggested_profile") return SugestedUserIcon;

    return InterestRejectIcon; // fallback
  };

  const checkScrollPosition = () => {
    const slider = sliderRef.current;
    if (!slider) return;

    const tolerance = 10;

    setAtStart(slider.scrollLeft <= tolerance);
    setAtEnd(
      slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - tolerance,
    );
  };

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const update = () => checkScrollPosition();

    requestAnimationFrame(update);
    slider.addEventListener("scroll", update);

    return () => slider.removeEventListener("scroll", update);
  }, []);

  useEffect(() => {
    requestAnimationFrame(checkScrollPosition);
  }, [activityCount]);

  useEffect(() => {
    const fetchActivity = async () => {
      setLoading(true);
      try {
        const response = await getAllActivityJava();

        if (response.status === 200 && response.data?.status) {
          setActivity(response.data.data || {});
        } else {
          console.error("Invalid activity response", response.data);
        }
      } catch (error) {
        console.error("❌ JAVA ACTIVITY API ERROR:", error);
        toast.error("Failed to load activity");
      }
    };

    const fetchAllCount = async () => {
      try {
        const response = await getActivityCountJava();

        //  console.log("🔥 COUNT API RAW RESPONSE:", response);
        // console.log("🔥 COUNT API DATA:", response.data);
        //  console.log("🔥 COUNT KEYS:", Object.keys(response.data));

        if (response.status === 200 && response.data?.success) {
          setActivityCount(response.data.counts || {});
        } else {
          console.error("Invalid activity count response", response.data);
        }
      } catch (error) {
        console.error("❌ JAVA COUNT API ERROR:", error);
        toast.error("Failed to load activity counts");
      } finally {
        setLoading(false);
      }
    };

    fetchActivity();
    fetchAllCount();
  }, []);

  const routeMap = {
    premium: "/premium",
    photo_upload: "/upload-image",
    register: "/register",
  };

  // const handleViewAllClick = (matchesType) => {
  //   navigate(`/${matchesType}`);
  //   console.log("➡️ VIEW ALL CLICK:", matchesType);
  // };

  const handleViewAllClick = (matchesType) => {
    const path = routeMap[matchesType] || `/${matchesType}`;
    navigate(path);
  };

  const handleSearch = (profileId) => {
    try {
      logEvent(analytics, "view_profile", {
        viewed_profile_id: profileId,
        profile_viewer_id: localStorage.getItem("user"),
        timestamp: new Date().toISOString(),
      });
      startTransition(() => {
        // navigate("/profile-view", { state: { user_id: profileId } });
        navigate("/profile-view", { state: { username: profileId } });
      });
    } catch (error) {
      toast.error("Something Went Wrong:", error);
    }
  };

  const formatTitle = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  //  CONTROL TITLES HERE
  const activityTitleMap = {
    recently_join_profile: "Recently Joined",
    my_matches: "My Matches",
    my_online_matches: "Online Matches",
    who_looking_for_me: "Looking For Me",
    premium: "Premium Matches",
    featured_profile: "Featured Profiles",
    who_view_my_profile: "Profile Visitors",
    profile_i_viewed: "Profiles I Viewed",
    who_short_list_me: "Who Shortlisted Me",
    interest_i_accept: "Interest I Accepted",
    interest_received: "Interest Received",
    
    interest_i_reject: "Interest I Rejected",
    interest_sent: "Interest Sent",
    my_interest_accepted: "My Interest Accepted",
    my_interest_rejected: "My Interest Rejected",
    my_bookmark: "My Bookmark",
    contact_i_viewed: "Contact I Viewed",
    match_i_ignore: "Matches I Ignore",
    blocked_user: "Blocked Users",
  };

  const activityOrder = [
    "my_matches",
    "recently_join_profile",
    "my_online_matches",
    "who_looking_for_me",
    "premium",
    "featured_profile",
    "who_view_my_profile",
    "profile_i_viewed",
    "who_short_list_me",
    "interest_received",
    "interest_i_accept",
    "interest_i_reject",
    "interest_sent",
    "my_interest_accepted",
    "my_interest_rejected",
    "my_bookmark",
    "contact_i_viewed",
    "match_i_ignore",
    "blocked_user",
  ];

  const activityCountArray = Object.keys(activityCount)
    .filter((key) => {
      if (key === "suggested_profile") return false; // remove suggested

      if (key === "my_online_matches") {
        return activityCount[key] >= 1; // show only if 1 or more
      }

      return true;
    })
    .sort((a, b) => {
      const indexA = activityOrder.indexOf(a);
      const indexB = activityOrder.indexOf(b);

      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    })
    .map((key) => ({
      // title: key.replace(/_/g, " ").toUpperCase(),
      title: activityTitleMap[key] || key,
      title_key: key,
      count: activityCount[key],
    }));

  //   const renderSlider = () => {
  //   if (!activity || typeof activity !== "object") return null;

  //   return activityOrder
  //     .filter((key) => {
  //       if (!activity[key]) return false;

  //       // ❌ remove suggested profile completely
  //       if (key === "suggested_profile") return false;

  //       return true;
  //     })
  //     .map((key) => {
  //       const value = activity[key];
  //       const profiles = value?.profiles || [];

  //       if (profiles.length === 0) return null;

  //       return (
  //         <div key={key}>
  //           <SliderComponent
  //             data={profiles}
  //             // title={formatTitle(key)}
  //             title={activityTitleMap[key] || key}
  //             matchesType={key}
  //             total={value?.count || 0}
  //             onViewAllClick={handleViewAllClick}
  //             onProfileClick={(username) => handleSearch(username)}
  //           />
  //         </div>
  //       );
  //     });
  // };

  const renderSlider = () => {
    if (!activity || typeof activity !== "object") return null;

    return activityOrder
      .filter((key) => {
        const section = activity[key];
        if (!section) return false;

        // remove suggested
        if (key === "suggested_profile") return false;

        // only show if profiles exist
        return Array.isArray(section.profiles) && section.profiles.length > 0;
      })
      .map((key) => {
        const value = activity[key];

        return (
          <div key={key}>
            <SliderComponent
              data={value.profiles}
              title={activityTitleMap[key] || key}
              matchesType={key}
              total={value?.count || 0}
              onViewAllClick={handleViewAllClick}
              onProfileClick={(username) => handleSearch(username)}
            />
          </div>
        );
      });
  };

  const scrollSlider = (dir) => {
    if (!sliderRef.current) return;

    const amount = dir === "left" ? -300 : 300;
    sliderRef.current.scrollBy({ left: amount, behavior: "smooth" });

    setTimeout(checkScrollPosition, 300);
  };

  return (
    <Box className="col-lg-9 col-12">
      <Box sx={{ width: "100%" }}>
        <Box className="activPro">
          {loading ? (
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              <Skeleton
                variant="rectangular"
                width="200px"
                height="80px"
                sx={{ margin: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width="200px"
                height="80px"
                sx={{ margin: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width="200px"
                height="80px"
                sx={{ margin: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width="200px"
                height="80px"
                sx={{ margin: 1 }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                padding: "20px",
                borderRadius: "20px",
                marginBottom: "25px",
                position: "relative",
              }}
            >
              {/* HEADER */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "15px",
                }}
              >
                {/* LEFT — BACK ARROW + HEADING */}
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <img
                    src={backArrow}
                    alt="back"
                    style={{ width: "28px", height: "28px", cursor: "pointer" }}
                    onClick={() => navigate(-1)}
                  />
                  <h5 style={{ fontWeight: 700, margin: 0 }}>
                    View All Activity
                  </h5>
                </Box>

                {/* RIGHT — CAROUSEL ARROWS */}

                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  {/* LEFT ARROW */}
                  <Button
                    onClick={() => !atStart && scrollSlider("left")}
                    disabled={atStart}
                    sx={{
                      minWidth: "35px",
                      height: "35px",
                      borderRadius: "5px",
                      background: "#FFF", // keep original
                      boxShadow: "0px 3px 10px rgba(128, 144, 155, 0.20)",
                      cursor: atStart ? "not-allowed" : "pointer",
                    }}
                  >
                    <Box
                      sx={{
                        width: "14px",
                        height: "14px",
                        maskImage: `url(${arrowLeft})`,
                        WebkitMaskImage: `url(${arrowLeft})`,
                        maskRepeat: "no-repeat",
                        WebkitMaskRepeat: "no-repeat",
                        maskPosition: "center",
                        WebkitMaskPosition: "center",

                        maskSize: "contain",
                        WebkitMaskSize: "contain",
                        background: atStart
                          ? "#C0C0C0"
                          : "linear-gradient(0deg, rgba(230,0,0,0.81) 0%, rgba(255,119,5,0.87) 100%)",
                      }}
                    />
                  </Button>

                  {/* RIGHT ARROW */}
                  <Button
                    onClick={() => !atEnd && scrollSlider("right")}
                    disabled={atEnd}
                    sx={{
                      minWidth: "35px",
                      height: "35px",
                      borderRadius: "5px",
                      background: "#FFF",
                      boxShadow: "0px 3px 10px rgba(128, 144, 155, 0.20)",
                      cursor: atEnd ? "not-allowed" : "pointer",
                    }}
                  >
                    <Box
                      sx={{
                        width: "14px",
                        height: "14px",
                        maskImage: `url(${arrowRight})`,
                        WebkitMaskImage: `url(${arrowRight})`,
                        maskRepeat: "no-repeat",
                        WebkitMaskRepeat: "no-repeat",
                        maskPosition: "center",
                        maskSize: "contain",
                        WebkitMaskSize: "contain",
                        WebkitMaskPosition: "center",
                        background: atEnd
                          ? "#C0C0C0"
                          : "linear-gradient(0deg, rgba(230,0,0,0.81) 0%, rgba(255,119,5,0.87) 100%)",
                      }}
                    />
                  </Button>
                </Box>
              </Box>

              {/* SCROLL ROW */}
              <Box
                ref={sliderRef}
                sx={{
                  display: "flex",
                  overflowX: "auto",
                  gap: "20px",
                  paddingBottom: "5px",

                  scrollbarWidth: "none",
                  "&::-webkit-scrollbar": { display: "none" },
                }}
              >
                {activityCountArray.map((item, index) => {
                  // console.log("TITLE KEY:", item.title_key);
                  return (
                    <Box
                      key={index}
                      onClick={() => handleViewAllClick(item.title_key)}
                      sx={{
                        width: "auto",
                        minWidth: "230px",
                        height: "87px",
                        background: "#FFF",
                        borderRadius: "16px",
                        // boxShadow: "0px 20px 60px rgba(128,144,155,0.20)",
                        cursor: "pointer",
                        padding: "12px",
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        flexShrink: 0,
                      }}
                    >
                      {/* ICON */}

                      <img
                        src={getActivityIcon(item.title_key)}
                        alt="icon"
                        style={{ width: "48px", height: "48px" }}
                      />

                      {/* TEXT */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "24px",
                            fontWeight: 600,
                            textAlign: "start",
                          }}
                        >
                          {item.count}
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: "15px",
                            color: "#8A97A4",
                            textAlign: "start",
                          }}
                        >
                          {item.title.replace(/_/g, " ")}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )}

          <Box className="scrollProfileSec">{renderSlider()}</Box>
        </Box>
      </Box>
    </Box>
  );
};
